<template>
  <div v-if="detailsData.data">
    <div
      v-if="
        (detailsData.data && detailsData.data.userType == 0) ||
        detailsData.data.userType == 2
      "
      class="Publisher"
    >
      <div class="title">发布者</div>
      <div @click="goBkOrBj" class="logo">
        <img
          v-if="autherInfo.headImg"
          v-lazy="`${$global.imgUrl}${autherInfo.headImg}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/qikan.png" alt="" />
        <span>{{ autherInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div v-if="autherInfo.foundedDate" class="listItem">
          <div class="time">{{ autherInfo.foundedDate }}</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ timeData.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div class="listItem">
          <div class="time">{{ timeData.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div v-if="timeData.letterCount" class="listItem">
          <div class="time">{{ timeData.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div
      v-if="detailsData.data && detailsData.data.userType == 1"
      class="Publisher"
    >
      <div class="title">期刊</div>
      <div @click="goBk" class="logo">
        <img
          v-if="periodicalInfo.periodicalLogo"
          v-lazy="`${$global.imgUrl}${periodicalInfo.periodicalLogo}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/qikan.png" alt="" />
        <span>{{ periodicalInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div class="listItem">
          <div class="time">{{ periodicalInfo.foundedDate }}</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ periodiID.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ periodiID.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ periodiID.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div class="videoList">
      <div class="videoTitle">最新视频</div>

      <div class="videoItem" v-for="item in videoList" :key="item.id">
        <div class="left">
          <img
            @click="goVideo(item)"
            v-lazy="`${$global.imgUrl}${item.cover}`"
            alt=""
          />
          <div class="time">{{ item.videoLong }}</div>
        </div>
        <div class="right">
          <div @click="goVideo(item)" class="videoStitle">{{ item.title }}</div>
          <div class="num">
            <img class="eye" src="@/assets/img/details/eye.png" alt="" />
            <div>{{ item.view }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="wenxian">-->
    <!--      <div class="title">最新资讯</div>-->
    <!--      <ul class="ulList">-->
    <!--        <li-->
    <!--          :class="i + 1 === wenxian.length ? '' : 'msg'"-->
    <!--          v-for="(item, i) in wenxian"-->
    <!--          :key="item.articleId"-->
    <!--        >-->
    <!--          {{ item.title }}-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "center",
  mounted() {},
  props: [
    "detailsData",
    "wenxian",
    "autherList",
    "autherInfo",
    "periodicalInfo",
  ],
  data() {
    return {
      timeData: {},
      videoList: [],
    };
  },
  watch: {
    detailsData() {
      this.getPublisherInfo();
      this.getVideo();
      console.log(this.detailsData);
    },
  },
  methods: {
    goVideo(item) {
      this.$router.push(
        `/videoDetails?id=${item.id}&type=${this.$router.history.current.query.type}&cid=${this.$router.history.current.query.cid}`
      );
    },
    async getVideo() {
      let arr = {};
      if (sessionStorage.getItem("Table")) {
        arr = JSON.parse(sessionStorage.getItem("Table")).PlatformEnum;
      } else {
        await this.getTable();
        arr = JSON.parse(sessionStorage.getItem("Table")).PlatformEnum;
      }
      let PlatformEnumObj = {};
      arr.forEach((item) => {
        if (item.name === "中文知识网") {
          PlatformEnumObj = item;
        }
      });
      const obj = {
        pid: PlatformEnumObj.id,
        cid: this.$router.history.current.query.cid,
        pageSize: 5,
        pageNum: 1,
      };
      let res = await this.$apis.recomendServe.newVideos(obj);
      this.videoList = res.data.list;
      console.log(this.videoList);
    },
    goBk() {
      // console.log(this.periodicalInfo.id);
      this.$router.push(
        `/bkzxdetail?title=百科在线&id=${this.periodicalInfo.id}`
      );
    },
    goBkOrBj() {
      console.log(this.detailsData);
      this.$router.push(
        `/${
          this.detailsData.data.userType === 1 ? "bkzxdetail" : "bjzxdetail"
        }?title=${
          this.detailsData.data.userType === 1 ? "百科在线" : "百家在线"
        }&id=${
          this.detailsData.data.userType === 1
            ? this.detailsData.data.companyId
            : this.detailsData.data.createUser
        }`
      );
    },
    async getPublisherInfo() {
      let PublisherObj = {
        companyId: this.detailsData.data.companyId
          ? this.detailsData.data.companyId
          : null,
        createUser: this.detailsData.data.createUser,
      };
      console.log(PublisherObj, "PublisherObj");
      const timeData = await this.$apis.recomendServe.PublisherInfo(
        PublisherObj
      );
      this.timeData = timeData.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.wenxian {
  width: 270px;
  //height: 250px;
  //padding-left: 25px;
  padding-top: 20px;
  padding-bottom: 40px;
  background: #ffffff;
  margin-left: 10px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
  //.xian{
  //  width: 270px;
  //  height: 1px;
  //  top: 60px;
  //  border: 1px solid #E5E5E5;
  //  background: pink;
  //  right: 0px;
  //}
  .ulList {
    padding-left: 25px;
    padding-right: 25px;

    li {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }

    .msg {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      //line-height: 24px;
      border-bottom: 1px dashed #e8e8e8;
      //border-style: dashed;
    }
  }

  .title {
    font-size: 18px;

    font-weight: bold;
    height: 20px;
    line-height: 20px;
    color: #333333;
    width: 270px;
    padding-left: 25px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e5e5e5;
    //border-bottom: 1px solid #000;
  }
}

.videoList {
  width: 295px;
  height: 493px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
  margin-left: 10px;
  padding-left: 30px;
  padding-top: 26px;
  padding-right: 20px;

  .videoTitle {
    height: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
  }

  .num {
    display: flex;
    .eye {
      width: 13px;
      height: 9px;
      margin-top: 10px;
    }
    div {
      margin-left: 2px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      opacity: 0.52;
      vertical-align: middle;
    }
  }
  .videoItem {
    height: 80px;
    border-bottom: 1px #e5e5e5 dashed;
    border-top: 1px #e5e5e5 dashed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .time {
      position: absolute;
      top: 40px;
      left: 8px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }

    .videoStitle {
      overflow: hidden;
      text-overflow: ellipsis; //文本超出省略
      display: -webkit-box;
      cursor: pointer;
      -webkit-line-clamp: 2; //第几行省略就设置第几行
      -webkit-box-orient: vertical;
      width: 140px;
      height: 34px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }

    .left {
      img {
        width: 100px;
        height: 56px;
        cursor: pointer;
        border-radius: 4px;
      }
    }
  }
}

.Publisher {
  width: 295px;
  height: 250px;
  padding-left: 40px;
  padding-top: 20px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.07);
  margin-left: 10px;
  margin-bottom: 10px;

  .title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    //line-height: 24px;
  }

  .logo {
    display: flex;
    width: 220px;
    flex-wrap: wrap;
    //background: pink;
    justify-content: center;
    margin-top: 10px;

    img {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      cursor: pointer;
    }

    span {
      cursor: pointer;
      margin-top: 15px;
      text-align: center;
      width: 245px;
      height: 18px;
      font-size: 18px;
      //font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
  }

  .list {
    width: 220px;
    display: flex;
    margin-top: 24px;
    justify-content: space-around;

    .listItem {
      width: 50px;
      height: 50px;
      text-align: center;
      align-items: center;
      margin-top: -5px;
      .text {
        text-align: center;
        //width: 48px;
        //height: 11px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }

      .time {
        //background: pink;
        //width: 44px;
        //height: 17px;
        font-size: 20px;
        font-family: Dancing Script;
        font-weight: bold;
        color: #ff7d14;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
</style>
